import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import i18n from 'locales/i18next';

import { OrderItem, OrderItemType } from 'types/pwcOrder';

import { getCurrencySymbol } from 'utils/currencies';
import formatNumber from 'utils/numbers';

import { Item, ItemName, ItemValue } from '../../styles';
import LABELS, { KEYS } from './keys';
import { ItemValueWrapper, StyledItemValue } from './styles';

interface OrderItemProps {
  orderItem: OrderItem;
  fiatCurrencyCode: string;
  index: number;
}

export const OrderItemComponent = ({ orderItem, fiatCurrencyCode, index }: OrderItemProps) => {
  const { fiatAmount } = orderItem;
  const itemCount = index + 1;
  const showCount = orderItem.type === OrderItemType.Product;
  const { t } = useTranslation();

  const itemName = useMemo(() => {
    const nameKey = orderItem.type === KEYS.DELIVERY ? LABELS.DELIVERY_FEE : orderItem.name;
    return t(nameKey);
  }, [t, orderItem]);

  const displayName = showCount ? t(LABELS.ITEM_NAME_WITH_COUNT, { itemCount, itemName }) : itemName;

  return (
    <Item>
      <ItemName>{displayName}</ItemName>
      <ItemValueWrapper>
        <ItemValue>{getCurrencySymbol(i18n.language)(fiatCurrencyCode)}</ItemValue>
        <StyledItemValue>{formatNumber(fiatAmount)}</StyledItemValue>
      </ItemValueWrapper>
    </Item>
  );
};
